import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ZuperDrawerComponent, ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { v4 as uuidv4 } from 'uuid';
import { DispatchFilterOptions } from '../../../../../dispatch-board/src/app/components/dispatch-filter/dispatch-filter.interface';

@Component({
  selector: 'app-calendar-filter-drawer',
  templateUrl: './calendar-filter-drawer.component.html',
  styleUrls: ['./calendar-filter-drawer.component.scss']
})
export class CalendarFilterDrawerComponent implements OnInit, OnChanges {
  @Input() openFilter: boolean = false;
  @Input() isNewFilter: boolean = false;
  @Input() isMapViewEnabled: boolean = false;
  @Input() dateRange: { fromDate: string; toDate: string } = null;
  @Output() filterDrawerEmitter: EventEmitter<any> = new EventEmitter();
  @Input() jobCalendarFilterValues: any = null;
  @Input() filterOptions: DispatchFilterOptions;
  @Input() saveFilterByDefault: boolean;
  @Input() hideSaveFilter: boolean;
  @Output() filterEmitter: EventEmitter<any> = new EventEmitter();

  drawerName: string = 'dispatch_filter';
  filterEmitValue: any = null;

  constructor(
    private zuperDrawerService: ZuperDrawerService) {
  }

  ngOnInit(): void {
    this.drawerName = this.drawerName + '_' + uuidv4();
  }

  filterEventHandler(event: any): void {
    // if (event.isClosed) {
      this.openFilter = false;
      this.filterEmitValue = event;
      this.drawerClose();
    // }
  }

  //#region Drawer Related Methods
  drawerOpenedChanged(isOpened: boolean): void {
    if (!isOpened) {
      this.filterDrawerEmitter.emit(this.filterEmitValue ?? { isClosed: true });
    }
  }

  drawerClose(): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    drawer.close();
  }

  toggleDrawer(isOpen: boolean): void {
    const drawer: ZuperDrawerComponent = this.zuperDrawerService.getComponent(this.drawerName);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen ? drawer?.open() : this.drawerClose();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.openFilter?.previousValue !== undefined) {
      this.toggleDrawer(changes?.openFilter.currentValue);
    }
  }
}
